export default __webpack_public_path__ + "static/media/default-profile-moose.4474f3c1.jpg";